// Keep CDK drag/drop move listeners active so preventDefault can suppress page scrolling.
(window as any).__zone_symbol__UNPATCHED_EVENTS = ["mousemove", "touchmove"];
